interface StoreItem {
	item: string;
	__expiration?: number;
}

export function setStorageItem(key: string, item: string, expirationInHours?: number): void {

	const storeItem: StoreItem = {
		item: item
	};

	if (expirationInHours) {
		storeItem.__expiration = Date.now() + (expirationInHours * 60 * 60 * 1000);
	}

	localStorage.setItem(key, JSON.stringify(storeItem));
}

export function setStorageObject(key: string, item: any | { [key: string]: any }, expirationInHours?: number): any {
	if (expirationInHours) {
		item.__expiration = Date.now() + (expirationInHours * 60 * 60 * 1000);
	}

	localStorage.setItem(key, JSON.stringify(item));
}

/**
 * 
 * @param {string} key 
 */
export function getStorageItem(key: string): any | null {
	const str = localStorage.getItem(key);

	if (str) {
		const item = JSON.parse(str);

		if (item.__expiration && item.__expiration < Date.now()) {
			removeStorageItem(key);
			return null;
		} else {
			return item.item;
		}
	} else {
		return null;
	}
}

export function getStorageObject(key: string): any | null {
	const str = localStorage.getItem(key);

	if (str) {
		const item = JSON.parse(str);

		if (item.__expiration && item.__expiration < Date.now()) {
			removeStorageItem(key);
			return null;
		} else {
			return item;
		}
	} else {
		return null;
	}
}

export function removeStorageItem(key: string): void {
	localStorage.removeItem(key);
}

export function clearStorage(): void {
	localStorage.clear();
}